import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import HeaderTop from '../HeaderTop';
import MainMenu from '../MainMenu';
import './Header.scss';

const Header = (props) => {
  const { siteConfig, i18n } = props;
  const { data = {} } = siteConfig;
  const { header_style = 1, enableSSO = false, mobileHeaderStyle = 1 } = data;
  const { header_config = {}, menu_config = {} } = data[i18n.locale] || {};
  const {
    header_banner = '',
    header_logo = '',
    header_logo_mobile = '',
    header_logo_tablet = '',
    header_background_color = '',
    header_title = '',
  } = header_config;
  const { translations = {}, locale } = i18n || {};

  return (
    <header>
      <HeaderTop
        curLang={locale}
        translations={translations[locale]}
        enableTSSSO={enableSSO}
        className={mobileHeaderStyle === 2 ? 'hideTablet' : ''}
      />
      <Container>
        <Row>
          <Col>
            <MainMenu
              curLang={i18n.locale}
              logo={{
                imgSrc: header_logo,
                imgSrcMobile: header_logo_mobile,
                imgSrcTablet: header_logo_tablet,
                bgColor: header_background_color,
                title: header_title,
              }}
              banner={{ imgSrc: header_banner, title: header_title }}
              menu={menu_config}
              headerStyle={header_style}
              enableTSSSO={enableSSO}
              mobileHeaderStyle={mobileHeaderStyle}
            />
          </Col>
        </Row>
      </Container>
    </header>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(Header);

export { Header as HeaderComponent }; // <- For component Unit Test
export default connectStore;
